import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import { List } from 'immutable';
import { createSelector } from 'reselect';

import { push } from 'react-router-redux';
import {RelationshipActions} from '../actions/relationship';
import { ModalActions } from '../actions/modal';

import {
  currentElementIdSelector,
} from '../reducers/elements';

// import '../styles/ProjectTab.css';

class RelationshipRow extends Component {
  static propTypes = {
    relationships: PropTypes.instanceOf(List)
  }

  confirmDelete() {
    const {dispatch} = this.props;
    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'relationship',
        handleDelete: ::this.handleDelete
      }
    }));
  }

  handleDelete(){
    const { relationship, currentProjectId, dispatch } = this.props;

    dispatch(RelationshipActions.deleteRelationship(relationship, false));
    dispatch(push(`/project/${currentProjectId}/default`));
  }

  render() {
    const {relationship, currentProjectId} = this.props;

    const elementId = (this.props.type === 'providesTo') ? relationship.getIn(['consumer','id']) : relationship.getIn(['producer','id']);
    const elementName = (this.props.type === 'providesTo') ? relationship.getIn(['consumer','name']) : relationship.getIn(['producer','name']);
    const typeId = relationship.getIn(['type','id']);
    const typeName = relationship.getIn(['type','type']);
    const relationshipId = relationship.get('id');
    const strength = relationship.get('strength');

    return <tr>
      <td><Link style={{display: 'block'}} to={`/project/${currentProjectId}/element/${elementId}`}>{elementName}</Link></td>
      <td><Link to={`/project/${currentProjectId}/relationship-type/${typeId}`}>{typeName}</Link></td>
      <td>{strength}</td>
      <td>
        <button type="button" className="btn btn-primary btn-sm">
          <Link style={{color: '#fff'}} to={`/project/${currentProjectId}/relationship/${relationshipId}`}>
            <i className="fa fa-eye"></i>
          </Link>
        </button>
        <button onClick={::this.confirmDelete} type="button" className="btn btn-danger btn-sm"><i className="fa fa-times"></i></button>
      </td>
    </tr>
  }
}

export const buildRelationships = (relationships, relationshipIds, elements, relationshipTypes) => {
  return relationshipIds.map((relationshipId) => {
    let relationship = relationships.get(relationshipId);
    const producerElement = elements.get(relationship.get('producer'));
    const consumerElement = elements.get(relationship.get('consumer'));

    if(!relationship.has('type')) {
      relationship = relationship.set('type', relationshipTypes.get(relationship.get('type_id')));
    }

    return relationship.set('producer', producerElement).set('consumer', consumerElement);
  });
}

export const elementsSelector = (state, props) => {
  return state.elements.get('elements');
}

const currentProjectIdSelector = (state, props) => {
  return state.projects.get('currentProjectId');
}

export const elementsRelationshipsSelector = (state, props) => {
  return state.elementsRelationships.get('elementsRelationships');
}

export const relationshipsSelector = (state, props) => { // type: providesTo | consumesFrom
  return state.relationships.get('relationships');
}

export const relationshipTypesSelector = (state, props) => { // type: providesTo | consumesFrom
  return state.relationshipTypes.get('relationshipTypes');
}

export const providesToConsumesFromSelector = (state, props) => {
  return elementsRelationshipsSelector(state, props).getIn([currentElementIdSelector(state, props), props.type], List());
}

const ElementRelationshipsContainerSelector = createSelector(
  [currentElementIdSelector, elementsSelector, providesToConsumesFromSelector, relationshipsSelector, relationshipTypesSelector, currentProjectIdSelector],
  (currentElementId, elements, providesToConsumesFrom, relationships, relationshipTypes, currentProjectId) => {
    return {
      currentElementId,
      relationships: buildRelationships(relationships, providesToConsumesFrom, elements, relationshipTypes),
      currentProjectId
    };
  }
);

@connect(ElementRelationshipsContainerSelector)
export default class ElementRelationshipsContainer extends Component {
  static propTypes = {
    relatedElementArray: PropTypes.instanceOf(List)
  };

  render() {
    return (this.props.relationships ? <ElementRelationships {...this.props} /> : <div />);
  }
}

class ElementRelationships extends Component {
  static propTypes = {
    relationships: PropTypes.instanceOf(List)
  }

  buildChildrenStrings = () => {
    const {
      relationships,
    } = this.props;

    if(relationships && !relationships.size) return;

    var childrenList = relationships.map((relationship, key) => {
      return <RelationshipRow {...this.props} relationship={relationship} key={key} />;
    });

    const output = (childrenList.size) ? childrenList : <div/>;
    return output;
  }

  render() {
    const {relationships} = this.props;

    if(!relationships || relationships.size === 0) return <div/>;
    const childrenStrings = this.buildChildrenStrings();

    return (
      <div className="relationship-wrapper">
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Element</th>
              <th>Relationship Type</th>
              <th>Strength</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {childrenStrings}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ElementRelationships.js